// extracted by mini-css-extract-plugin
export default {"fab-scroll-top":"ScrollToTopButton_fab-scroll-top__pxPtJ"};